export default __webpack_public_path__ + "static/countdown_widget_expanded-f6e7f94adb5833b29767db0e5b35f018.png";